module.exports = __webpack_public_path__ + "img/logo.977b86c6.png";